import client from './client'
import {
  UserInfo,
  UserLogin,
  WeChatInfo,
  UpdateUserInfo,
  UserVerification,
  UserVerificationInfo,
  Organizationinfo,
  ListResponse,
  PermissionInfo,
} from '@/types'

export const getUserInfo = () => {
  return client<UserInfo>({
    method: 'get',
    url: 'user/profile',
  })
}

export const updateUserName = (data: { nickname: string; head_img_url?: string }) => {
  return client<unknown>({
    method: 'put',
    url: 'user/profile',
    data,
  })
}

export const bindMail = (data: { code: string; mail: string }) => {
  return client({
    url: 'user/profile/bind/mail',
    method: 'put',
    data,
  })
}

export const getBindMailCode = (data: { mail: string }) => {
  return client({
    url: 'user/bind/mail',
    method: 'post',
    data,
  })
}

export const bindMobile = (data: { phone_number: string; code: string }) => {
  return client({
    url: 'user/profile/bind/mail',
    method: 'put',
    data,
  })
}

export const getBindMobileCode = (data: { phone_number: string }) => {
  return client({
    url: 'user/bind/mail',
    method: 'post',
    data,
  })
}

export const bindWeChatInfo = () => {
  return client<WeChatInfo>({
    url: 'user/bind/wechat',
    method: 'get',
  })
}

export const updatePassword = (data: UpdateUserInfo) => {
  return client({
    url: 'user/password',
    method: 'put',
    data,
  })
}

export const userVerification = (data: UserVerification) => {
  return client<{ url: string; code: 0 | 1000 | 1001; second: number }>({
    url: 'apply/alipay/cert-url',
    method: 'post',
    data,
  })
}

export const checkVerification = () => {
  return client<UserVerificationInfo>({ url: 'user/certify', method: 'get' })
}

export const getUserOrganizations = (params?: { privilege: 'manager' | 'all' }) => {
  return client<ListResponse<Organizationinfo>>({
    url: 'user/organizations',
    method: 'get',
    params,
  })
}

export const getUerPermissions = (id: number) => {
  return client<ListResponse<PermissionInfo>>({
    url: `organizations/${id}/mine/permissions`,
    method: 'get',
  })
}

// kind: 1 登录 2 绑定 3 换绑 4 重置密码
export const postUserPhoneCode = (data: { phone: string; kind: 1 | 2 | 3 | 4 }) => {
  return client({
    url: 'user/phone/code',
    method: 'post',
    data,
  })
}

export const postUserPhoneBind = (data: { phone: string; code: string }) => {
  return client({
    url: 'user/phone/bind',
    method: 'post',
    data,
  })
}

export const postUserPhoneChange = (data: {
  old_phone: string
  old_code: string
  new_phone: string
  new_code: string
}) => {
  return client({
    url: 'user/phone/change',
    method: 'post',
    data,
  })
}

export const putUserPassword = (data: {
  phone: string
  code: string
  new_password: string
  confirm_password: string
}) => {
  return client({
    url: 'user/password',
    method: 'put',
    data,
  })
}

export const deleteUserCloseAccount = () => {
  return client({
    url: 'user/close_account',
    method: 'delete',
  })
}

export const postUserAvatar = (file: File) => {
  const formData = new FormData()
  formData.append('images', file)
  return client<{ head_img_url: string }>({
    url: 'user/avatar',
    method: 'post',
    data: formData,
  })
}
